import _api from '../_api';
import router from '../../../router';

import Store from '../../../models/Store';
import StoreReport from '../../../models/StoreReport';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    stores: [],
    reports: [],
    assignableStores: [],
    pageCount: 0,
    totalCount: 0,
    reportsPageCount: 15,
    reportsTotalCount: 0,
    isLoading: false,
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.stores,
    reports: (state,) => state.reports,
    filteredReports: (state,) => (filters,) => state.reports.filter((item,) => {
      let confirmation = true;
      Object.entries(filters,).forEach((filter,) => {
        if (filter[1]) {
          if (typeof filter[1] === 'string') {
            confirmation = item[filter[0]].

              toLowerCase().indexOf(filter[1].toLowerCase(),) >= 0;
          } else {
            confirmation = item[filter[0]] === filter[1];
          }
        }
      },);
      return confirmation;
    },),
    assignableStores: (state,) => state.assignableStores,
    reportsPageCount: (state,) => state.reportsPageCount,
    reportsTotalCount: (state,) => state.reportsTotalCount,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
    isLoading: (state,) => state.isLoading,
  },
  // -----------------------------------------------------------------
  mutations: {
    setStores: (state, stores,) =>
      (state.stores = stores),
    setPageCount: (state, pageCount,) =>
      (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) =>
      (state.totalCount = totalCount),
    setStoreReports: (state, reports,) =>
      (state.reports = reports),
    setReportsPageCount: (state, reportsPageCount,) =>
      (state.reportsPageCount = reportsPageCount),
    setReportsTotalCount: (state, reportsTotalCount,) =>
      (state.reportsTotalCount = reportsTotalCount),
    setAssignableStores: (state, assignableStores,) =>
      state.assignableStores = assignableStores,
    setLoading: (state, isLoading,) =>
      (state.isLoading = isLoading),
  },
  // -----------------------------------------------------------------
  actions: {
    get: ({ commit, },
      { page, name, published, publish_status,
        logisticOperator_id, sort, sortBy, dispatchType, },) => {
      commit('stores/setStores', [], { root: true, },);

      return _api.get({
        page, name, published, publish_status,
        logisticOperator_id, sort, sortBy, dispatchType,
      },).then((response,) => {
        const stores = response.data.items.map((store,) => new Store(store,),);
        commit('stores/setStores', stores, { root: true, },);
        commit('stores/setPageCount',
          Math.ceil(response.data.total_count / 15,),
          { root: true, },
        );
        commit('stores/setTotalCount', response.data.total_count, {
          root: true,
        },);

        return stores;
      },
      (error,) => _api.handleError(error,),
      );
    },
    getAll: (
      { commit, },
      filters,
    ) => {

      commit('stores/setStores', [], { root: true, },);
      commit('stores/setLoading', true, { root: true, },);

      return _api.getAll(filters,).then((response,) => {

        const stores = response.data.items.map((store,) => new Store(store,),);
        commit('stores/setStores', {
          ...response.data,
          items: stores,
        }, { root: true, },);
        commit('stores/setLoading', false, { root: true, },);

        return {
          ...response.data,
          items: stores,
        };
      },
      (error,) => _api.handleError(error,),
      );

    },
    getUserStores: (
      { commit, },
      filters,
    ) => {

      commit('stores/setStores', [], { root: true, },);
      commit('stores/setLoading', true, { root: true, },);

      return _api.getUserStores(filters,).then((response,) => {

        const stores = response.data.items.map((store,) => new Store(store,),);
        commit('stores/setStores', {
          ...response.data,
          items: stores,
        }, { root: true, },);
        commit('stores/setLoading', false, { root: true, },);

        return {
          ...response.data,
          items: stores,
        };
      },
      (error,) => _api.handleError(error,),
      );

    },
    getReports: async ({ commit, }, { begin_date, end_date, },) => {
      commit('stores/setStoreReports', [], { root: true, },);

      return new Promise((resolve, reject,) => {
        _api.
          getStoreReports({ begin_date, end_date, },).then(
            (response,) => {
              const reports = response.data.items.
                map((report,) => new StoreReport(report,),);
              commit('stores/setStoreReports', reports, { root: true, },);
              commit(
                'stores/setReportsPageCount',
                Math.ceil(response.data.total_count / 15,),
                { root: true, },
              );
              commit('stores/setReportsTotalCount', response.data.total_count, {
                root: true,
              },);

              return resolve(reports,);
            },).
          catch((error,) => {
            return error.response?.status === 400 ?
              reject(error.response.data.errors[0],) : _api.handleError(error,);
          },);
      },);
    },
    getAssignableStores: ({ commit, rootState, },) => {
      commit('stores/setAssignableStores', [], { root: true, },);
      return _api.getAssignableStores().then(
        (response,) => {
          const stores = [
            {
              text: 'Todas lojas',
              key: 'ALL',
              checked: false,
            },
            ...response.data.items.map((store,) => {
              const newStore = new Store(store,);
              newStore.checked = Boolean(rootState.
                driver.assignedStores.find((store,) => store._id === newStore._id,),);
              newStore.text = store.name;
              return newStore;
            },),
          ];

          commit('stores/setAssignableStores', stores, { root: true, },);
          return stores;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    create: async (_, value,) => {
      const newStore = new Store(value,).toPost;

      return new Promise((resolve, reject,) => {
        _api.
          post(newStore,).
          then((inserted,) => {
            router.push({
              name: 'store',
              params: { id: inserted.data._id, },
            },);

            resolve(inserted,);
          },).
          catch((error,) => {
            console.log('---------------',);

            reject(error.response,);
          },);
      },);
    },
    exportReport: async (_, { storeIds, begin_date, end_date, },) => {
      return new Promise((resolve, reject,) => {
        _api.
          exportStoreReports({ storeIds, begin_date, end_date, },).
          then((response,) => {
            resolve(response.data.message,);
          },).
          catch((error,) => {
            console.log('---------------',);

            return error.response?.status === 400 ?
              reject(error.response.data.errors[0],) : _api.handleError(error,);
          },);
      },);
    },
  },
};
